module.exports = __webpack_public_path__ + "static/media/sailboat.cbed006f.svg";